import { Routes } from '@angular/router';
import { AuthenticatedGuard } from './core/guards/authenticated.guard';
import { ApplicationResetResolver } from './core/resolvers/application-reset.resolver';

export const routes: Routes = [
  {
    path: 'welcome',
    resolve: { ApplicationResetResolver },
    loadChildren: () => import('./welcome/welcome.routes').then(m => m.WELCOME_ROUTES)
  },
  {
    path: 'application',
    loadChildren: () => import('./application/application.routes').then(m => m.APPLICATION_ROUTES),
    canActivate: [AuthenticatedGuard]
  },
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  { path: '**', redirectTo: 'welcome' },
];
